import type { CdekTariffType, CdekTrackingData } from '../schemas/cdek.schema'
import { apiFetch, readApiJson } from '@/lib/api-fetch'

export async function fetchCdekEstimate(
  toCity: string
): Promise<{ tariffs: CdekTariffType[] }> {
  const res = await apiFetch(`/api/cdek/calculator?to_city=${encodeURIComponent(toCity)}`)
  return await readApiJson<{ tariffs: CdekTariffType[] }>(res)
}

export async function fetchCdekTracking(trackNumber: string, orderId?: number, refresh = false): Promise<CdekTrackingData> {
  const query = new URLSearchParams({ number: trackNumber })
  if (orderId) query.set('orderId', String(orderId))
  if (refresh) query.set('refresh', '1')
  const res = await apiFetch(`/api/cdek/track?${query}`)
  return await readApiJson<CdekTrackingData>(res)
}
